export const FETCH_STATE_LICENSE_REQUEST = "FETCH_STATE_LICENSE_REQUEST";
export const FETCH_STATE_LICENSE_SUCCESS = "FETCH_STATE_LICENSE_SUCCESS";
export const FETCH_STATE_LICENSE_FAILURE = "FETCH_STATE_LICENSE_FAILURE";

export const FETCH_STATE_LICENSE_NOTES_REQUEST = "FETCH_STATE_LICENSE_NOTES_REQUEST";
export const FETCH_STATE_LICENSE_NOTES_SUCCESS = "FETCH_STATE_LICENSE_NOTES_SUCCESS";
export const FETCH_STATE_LICENSE_NOTES_FAILURE = "FETCH_STATE_LICENSE_NOTES_FAILURE";

export const ADD_STATE_LICENSE_NOTE_REQUEST = "ADD_STATE_LICENSE_NOTE_REQUEST";
export const ADD_STATE_LICENSE_NOTE_SUCCESS = "ADD_STATE_LICENSE_NOTE_SUCCESS";
export const ADD_STATE_LICENSE_NOTE_FAILURE = "ADD_STATE_LICENSE_NOTE_FAILURE";

export const CLEAR_STATE_LICENSE_NOTES = "CLEAR_STATE_LICENSE_NOTES";
